import { GptMessage } from '@services/nomos_api/entities/gptMessage'
import HTTPClient from '../..'
import { ChatCompletionMessageParam } from 'openai/resources'

export type Message = {
  gptMessages: GptMessage[]
  channel: {
    id: string
    type: string
  }
}

export type GptResponseEntity = {
  id?: string
  created_at?: string
  firstOfGroup?: boolean
  total?: number
  url?: string
  filters?: unknown
  gptMessage: ChatCompletionMessageParam
}

export const postChatMessageAPI = async (
  message: Message
): Promise<GptResponseEntity[]> => {
  const { data } = await HTTPClient.post<GptResponseEntity[]>(
    '/chat_events',
    message
  )
  return data
}
